/*
 * Header transparent-state bridge
 * --------------------------------
 * The theme's header only listens for `header:disable-transparent-header` and
 * `header:allow-transparent-header`. Other overlay components dispatch their
 * own events (desktop-menu:open/close, dialog:before-show/after-hide). This
 * bridge converts those into header events so the header goes solid while a
 * header-scoped overlay is open and returns to transparent on close.
 */

const HEADER_DIALOGS = 'search-panel, header-menu-drawer, header-menu-dropdown-sidebar';
const MOBILE_MQ = window.matchMedia('(max-width: 999px)');

function fireHeaderSolid() {
  document.dispatchEvent(new CustomEvent('header:disable-transparent-header', { bubbles: true }));
}

function fireHeaderTransparent() {
  // Transparent header is desktop-only by design. On mobile, refuse to ever
  // toggle back to transparent — keep the header solid regardless of whether
  // an overlay just closed.
  if (MOBILE_MQ.matches) return;
  document.dispatchEvent(new CustomEvent('header:allow-transparent-header', { bubbles: true }));
}

// Enforce solid header on mobile: fire on load and whenever the viewport
// crosses the mobile breakpoint (orientation change, resize).
function enforceMobileSolid() {
  if (MOBILE_MQ.matches) fireHeaderSolid();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enforceMobileSolid);
} else {
  enforceMobileSolid();
}
MOBILE_MQ.addEventListener('change', enforceMobileSolid);

// Mega menu (EditorialDesktopMenu dispatches desktop-menu:open/close)
document.addEventListener('desktop-menu:open', fireHeaderSolid);
document.addEventListener('desktop-menu:close', fireHeaderTransparent);

// Header-level dialogs (search, menu drawer) extend DialogElement which
// dispatches dialog:before-show on open and dialog:after-hide on close.
// These events are dispatched WITHOUT bubbles:true (theme.js:2184, 2230), so
// document-level listeners in the bubble phase never fire. Capture phase is
// still dispatched on ancestors regardless of bubble setting — use it here.
document.addEventListener('dialog:before-show', (e) => {
  if (e.target?.matches?.(HEADER_DIALOGS)) fireHeaderSolid();
}, { capture: true });

document.addEventListener('dialog:after-hide', (e) => {
  if (e.target?.matches?.(HEADER_DIALOGS)) fireHeaderTransparent();
}, { capture: true });
